import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation, Navigate, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BaseURL, uniqueToken } from "../../../api/DataApis";
import request from "../../../Apis/request";
import "./filtercategory.css";
import axios from "axios";
import ReactPaginate from 'react-paginate'; 


function DeletedFilterCategory() {
  document.title = "Master | Deleted Filter Category";
  const [FilterCategoryData, setFilterCategoryData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [userStatuses, setUserStatuses] = useState({});
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [statusListing, setStatusListing] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(0); 
  const [page, setPage] = useState(1); 
  const [Limit, setLimit] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");
  let navigate = useNavigate();
  const handleStatus = (e) => {
    setSelectedStatus(e.target.value);
  }
  const handleSearchTextChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };
  const handleReset = () => {
    setPage(1);
    setSearchQuery('');
    setSelectedStatus('');
    FetchfiltercategoryData();
  }


  const { pid } = useParams();

  const FetchfiltercategoryData = async () => {  // Add page with default value 1
    setLoading(true);
  
    // Base URL with the common parameters
    let url = `${BaseURL}/master?`;
  
    // Conditionally append the parent_id if pid exists
    if (pid) {
      url += `parent_id=${pid}`;
    } else {
      url += `type=filter_category`;
    }
  
    // Append the page number to the URL
    url += `&page=${page}`;
    url += `&searchText=${searchQuery}`;
    url +=  `&status=Deleted`;
  
    try {
      const res = await request({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  console.log("response", res);
      if (res && res?.data) {
        setFilterCategoryData(res?.data);
        setFilteredData(res?.data);
        setTotalCount(res?.totalCount || 0);
        setLimit(res?.limit);
      
        setPageCount(Math.ceil(res?.totalCount / res?.limit)); 
        console.log("Total Countttttt", totalCount);
        console.log("PageCountttttttt", pageCount);// For pagination control
      } else {
        setFilteredData([]); // If no data, ensure filteredData is empty
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData([]); // In case of error, set filteredData to empty
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    FetchfiltercategoryData(page);  // Ensure the page is passed when calling the function
  }, [page]);  // Re-fetch when page changes
  

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = FilterCategoryData.filter((item) => {
      return item?.value?.toLowerCase().includes(query);
    });
    setFilteredData(filtered);
  };

  const handleStatusType = async (event, CategoryId) => {
    const status = event.target.value;
  
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [CategoryId]: status
    }));
    Swal.fire({
      title: 'Updating Status...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const url = `${BaseURL}/master/change-status/${CategoryId}`;
    
   
  
    try {
      const response = await axios.put(url, {
        "status" : status
      }, {
        headers: {
          "Content-Type": "Application/json",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const fetchStatusListing = async () => {
    const apiEndpoint = `${BaseURL}/settings/charger/status`;

    setLoading(true);

    var url = apiEndpoint

    let res = await request({
      url: url,
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);
   
    if (res && res.data) {
      setStatusListing(res.data);
      }

    return [];
  };

  useEffect(() => {
    fetchStatusListing();
  }, []);
  const handleSearchSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
  
    if (!searchQuery.trim()) {
      // If no search query, fetch all data
      await FetchfiltercategoryData(); // Call the function to fetch all category data
      return;
    }
  
    setPage(1); // Reset to the first page when searching
    setLoading(true); // Start loading spinner
  
    const url = `${BaseURL}/master?page=${page}&searchText=${searchQuery}&status=${selectedStatus}`;
  
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      if (res && res?.data && res?.data?.data) {
        setFilteredData(res?.data?.data); 
        setPageCount(Math.ceil(res?.data?.totalCount / res?.data?.limit)); // Update page count based on results
        setTotalCount(res?.data?.totalCount);
      } else {
        setFilteredData([]); // If no data is returned, set filtered data to empty
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

console.log("filtercategoryDATA", filteredData);
console.log("limits", Limit);
console.log("pagecount", pageCount);
  return (
    <>
     <div className="container-fluid">
  <div className="row">
    <div className="col-sm-12">
      <div className="card">
        <div className="card-header pb-0" style={{padding: "none"}}>
          <div className="row align-items-center">
            {/* Left side: Heading */}
            <div className="col-6 d-flex align-items-center">
              <h4>Deleted Filter Category</h4>
  {/* <Link
    className="form-control d-inline-block"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      maxWidth: "200px",
      display: "inline-flex",
      alignItems: "center",
      overflow: "hidden",
      marginRight: "10px", // Space between the button and select box
    }}
    to="/masters/filtercategorylist/add"
  >
    <i className="fa fa-plus"></i> Add Filter Category
  </Link> */}

  {/* <select
    className="form-select"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      maxWidth: "150px", // Adjust as needed
    }}
    onChange={handleStatus} // Handle the change as needed
  >
    <option value="">Select Status</option>
    <option value="Active">Active</option>
    <option value="InActive">InActive</option>
    <option value="Deleted">Deleted</option>
  </select> */}
</div>


            {/* Right side: Search box */}
            <div className="col-6 text-right" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
  <input
    placeholder="Search"
    className="form-control d-inline-block"
    style={{
      width: "100%",
      maxWidth: "170px",
      border: "1px solid black",
      borderRadius: "34px",
      marginRight: "10px" // Adds space between the input and the button
    }}
    value={searchQuery}
    onChange={handleSearchTextChange}
  />
  <button className="btn btn-primary" onClick={handleSearchSubmit}>
    Search
  </button>

</div>


          </div>
        </div>
        <hr style={{ margin: "5px 0 5px 0" }} /> {/* Reduce bottom margin of the hr */}
        <div className="d-flex justify-content-between align-items-center" style={{ padding: "0" }}>
  <button className="btn btn-primary" style={{ height: "auto" }}>Total Categories :{totalCount}</button>
  
  <h5 className="caption-subject bold uppercase mx-3" style={{ margin: "0" }}>
  <button className="btn btn-primary" style={{ height: "auto" }} onClick={() => handleReset()}>
      Reset
    </button>
    <button className="btn btn-primary" style={{ height: "auto" }} onClick={() => navigate(-1)}>
      Back
    </button>
  </h5>
</div>


<div className="card-body" style={{ padding: "10px 0" }}> {/* Add padding to the body */}
  {loading ? (
    // Loader is shown while loading
    <div className="text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  ) : filteredData.length > 0 ? (
    <>
    
    <div className="table-responsive">
      <table className="display dataTable" id="advance-1">
        <thead>
          <tr>
            <th>#</th>
            <th>Image</th>
            <th>Category Name</th>
            <th>Created Date</th>
        
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((u, i) => (
            <tr key={u?._id}>
              <td>{(page - 1) * Limit + i + 1}</td>
              <td>
                {u?.master_image ? (
                  <img
                    src={u.master_image}
                    alt={`${u.title}`}
                    width="50"
                    height="50"
                  />
                ) : (
                  <span
                    style={{
                      display: "inline-block",
                      width: "50px",
                      height: "50px",
                    }}
                  ></span>
                )}
              </td>
              <td>
                <Link
                  to={`/masters/filtercategorylist/${u?._id}`}
                  state={{ FilterCategoryEditData: u }}

                >
                  {u?.title}
                </Link>
              </td>
              <td>{u?.createdAt}</td>
            
              <td>
        
           
                &nbsp;&nbsp;&nbsp;
                <Link
                  to={`/masters/filtercategorylist/view/${u?._id}`}
                  state={{ FilterCategoryViewtData: u }}
                >
                  <i
                    className="fa fa-eye"
                    style={{ fontSize: "18px" }}
                    title="View Category"
                  ></i>
                </Link>
             
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    
    </div>
      <div className="pagination-container mt-4">
      <ReactPaginate
        previousLabel={'Previous'}
        nextLabel={'Next'}
        breakLabel={'...'}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={'pagination'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
        forcePage={page - 1} 
      />
    </div>
    </>
  ) : (
    // "No Data" message is shown if no data is returned
    <div className="text-center">
      <p>No Data Available</p>
    </div>
  )}
</div>

      </div>
    </div>
  </div>
</div>

    </>
  );
}

export default DeletedFilterCategory;
